import React from 'react';
import { Box, Tooltip, styled } from '@mui/material';
import { InputSwitch, InputSwitchProps } from 'primereact/inputswitch';
import { tokens } from '../../theme/tokens';

interface TrackNowSwitchFieldProps extends InputSwitchProps {
  label?: string;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  showDisabledTooltip?: boolean;
}

const LabelContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '6px',
}));

const StyledLabel = styled(Box)(() => ({
  fontFamily: 'Area Normal, Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  color: tokens.colors.grey,
}));

const SwitchFieldContainer = styled(Box)(() => ({
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
}));

export const TrackNowSwitchField = ({
  label,
  helperText,
  required,
  disabled,
  showDisabledTooltip = true,
  ...props
}: TrackNowSwitchFieldProps) => {
  const switchComponent = (
    <SwitchFieldContainer>
      <InputSwitch disabled={disabled} {...props} />
    </SwitchFieldContainer>
  );

  return (
    <Box>
      {label && (
        <LabelContainer>
          <StyledLabel>
            {label}
            {required && <span style={{ color: tokens.colors.error, marginLeft: '4px' }}>*</span>}
          </StyledLabel>
        </LabelContainer>
      )}
      {disabled && showDisabledTooltip ? (
        <Tooltip title="Complete required fields to enable this field" arrow>
          <Box>{switchComponent}</Box>
        </Tooltip>
      ) : (
        switchComponent
      )}
      {helperText ? (
        <Box
          sx={{
            fontFamily: 'Area Normal, Inter, sans-serif',
            fontSize: '12px',
            fontWeight: 400,
            color: tokens.colors.error,
            mt: '4px',
          }}
        >
          {helperText}
        </Box>
      ) : null}
    </Box>
  );
};
